import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-181b4a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "editor-attribute-dialog"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "field" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "input"
}
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onChange", "placeholder"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "None", -1))
const _hoisted_12 = ["^value", "textContent"]
const _hoisted_13 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Confirm", -1))

import { PropType, onMounted, reactive, ref } from "vue";
import {
  getAttributeConfig,
  getElementName,
  getLabel,
  getPlaceholder
} from "../config";
import { Attribute } from "../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeDialog',
  props: {
  currentElement: {
    type: Object as PropType<HTMLElement>,
    required: true
  },
  show: {
    type: Boolean,
    required: true
  },
  uploadPath: {
    type: String,
    required: true
  }
},
  emits: ["confirm", "cancel"],
  setup(__props, { emit: __emit }) {

const props = __props;

const attributes = reactive<Attribute[]>([]);

onMounted(() => {
  for (var attr of props.currentElement.attributes) {
    const name = attr.name;
    attributes.push({ name, value: attr.value });
  }
});

const emit = __emit;

const confirm = () => {
  emit("confirm", attributes);
};

const cancel = () => {
  emit("cancel");
};

const filename = ref<HTMLInputElement[]>();
const upload = ref<HTMLInputElement[]>();
const attribute = ref();
const hasUpload = ref<boolean>(false);
const updateFile = (attr: Attribute, e: Event) => {
  hasUpload.value = true;

  attribute.value = attr;
};

const uploadFile = async () => {
  hasUpload.value = true;

  const input = upload.value;
  const files = input ? input[0].files : [];
  const file = files && files.length ? files[0] : null;

  if (!file) {
    throw new Error("File not selected");
  }

  const body = new FormData();

  body.set("filename", file.name);
  body.append("file", file);

  const result = await fetch(props.uploadPath, {
    method: "POST",
    body
  });

  const uploaded = (await result.text()).replace(/"/g, "");

  const index = attributes.findIndex((a) => a.name === attribute.value.name);

  if (index !== -1) {
    attributes[index].value = `/api/file/${uploaded}`.trim();
  }
};

return (_ctx: any,_cache: any) => {
  return (props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(confirm, ["prevent"]),
          class: "attribute-form"
        }, [
          _createElementVNode("h4", null, [
            _createElementVNode("span", {
              textContent: _toDisplayString(_unref(getElementName)(props.currentElement.tagName.toLowerCase()))
            }, null, 8, _hoisted_2),
            _createTextVNode(" options ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes, (attribute) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", {
                textContent: _toDisplayString(_unref(getLabel)(attribute.name))
              }, null, 8, _hoisted_4),
              (_unref(getAttributeConfig)(attribute.name).hasImageLookup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event),
                      ref_for: true,
                      ref_key: "filename",
                      ref: filename
                    }, null, 8, _hoisted_6), [
                      [_vModelText, attribute.value]
                    ]),
                    _createElementVNode("input", {
                      type: "file",
                      ref_for: true,
                      ref_key: "upload",
                      ref: upload,
                      onChange: (e) => updateFile(attribute, e),
                      placeholder: _unref(getPlaceholder)(attribute.name)
                    }, null, 40, _hoisted_7),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: !hasUpload.value,
                      onClick: uploadFile
                    }, " Upload ", 8, _hoisted_8)
                  ]))
                : (_unref(getAttributeConfig)(attribute.name).hasLinkLookup)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event),
                      placeholder: _unref(getPlaceholder)(attribute.name)
                    }, null, 8, _hoisted_9)), [
                      [_vModelText, attribute.value]
                    ])
                  : (_unref(getAttributeConfig)(attribute.name).options)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 2,
                        "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event)
                      }, [
                        _hoisted_11,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAttributeConfig)(attribute.name).options, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            "^value": opt.value,
                            textContent: _toDisplayString(opt.label)
                          }, null, 8, _hoisted_12))
                        }), 256))
                      ], 8, _hoisted_10)), [
                        [_vModelSelect, attribute.value]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 3,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event),
                        placeholder: _unref(getPlaceholder)(attribute.name)
                      }, null, 8, _hoisted_13)), [
                        [_vModelText, attribute.value]
                      ])
            ]))
          }), 256)),
          _createElementVNode("div", { class: "buttons" }, [
            _createElementVNode("button", {
              type: "button",
              onClick: cancel
            }, "Cancel"),
            _hoisted_14
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}
}

})